import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
import { Usuario } from "../Interfaces/Usuario";
import { formatDate } from "../utils/dateUtils";

// Função para buscar os usuários

export const buscarUsuariosService = async () => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/usuario`;

    try {
      const response = await axios.get(URL, {
        headers: { Authorization: Token.AuthStr },
      });

      const usuariosArray = response.data.map((p: Usuario) => {
        const formattedDate = formatDate(new Date(p.created_at));
        return {
          key: p.id,
          nacionalidade: p.nacionalidade,
          estadoCivil: p.estadoCivil,
          status: p.status,
          created_at: formattedDate,
        };
      });

      return usuariosArray; // Agora retorna o array processado
    } catch (error) {
      console.log(error);
    }
  }
  return []; // Retorna um array vazio se o Token não for válido
};

export {};
